import {Module} from "vuex";
import api from "@/services/apiService";
import {QuotaLineConfig, QuotaLineWeek} from "@/types/QuotaLineConfig";
import {AxiosResponse} from "axios";
import {QuotaLineAPIInterface} from "@/entity/Client";
import DateToString from "@/utils/DateToString";
import {Vue} from "vue-property-decorator";
import {ErrorService} from "@/services/ErrorService";

const quotaLine: Module<any, any> = {
  state: {
    quotaData: {} as Record<string, QuotaLineWeek>,
  },
  getters: {
    getData: (state) => (weekNumber: string): QuotaLineWeek => {// weekNumber contient aussi l'année -> 28-2020
      const data: QuotaLineWeek = state.quotaData[weekNumber];
      return {
        totalQuota: (typeof data?.totalQuota === "undefined") ? -1 : data.totalQuota,
        usedQuota: (typeof data?.usedQuota === "undefined") ? -1 : data.usedQuota,
        addedQuota: (typeof data?.addedQuota === "undefined") ? 0 : data.addedQuota,
        initialFormQuota: (typeof data?.initialFormQuota === "undefined") ? 0 : data.initialFormQuota,
      };
    },
    totalQuotaString: (state, getters) => (weekNumber: string) => {
      const data: QuotaLineWeek = getters.getData(weekNumber);
      if (data?.totalQuota !== -1) {
        return DateToString.convertTimeToString(data.totalQuota);
      }
      return '-';
    },
    usedQuotaString: (state, getters) => (weekNumber: string) => {
      const data: QuotaLineWeek = getters.getData(weekNumber);
      if (data?.usedQuota !== -1) {
        const finalUsed = data.usedQuota - data.initialFormQuota + data.addedQuota;
        return DateToString.convertTimeToString(finalUsed);
      }
      return '-';
    },
    finalUsedQuotaString: (state, getters) => (weekNumber: string) => {
      const data: QuotaLineWeek = getters.getData(weekNumber);
      if (data.usedQuota !== -1) {
        return DateToString.convertTimeToString(data.usedQuota - data.initialFormQuota + data.addedQuota);
      }
      return '-';
    },
    tooltipContent: (state, getters) => (weekNumber: string) => {
      const data: QuotaLineWeek = getters.getData(weekNumber);
      if (data.usedQuota !== -1 && data.totalQuota !== -1) {
        const finalUsed = data.usedQuota - data.initialFormQuota + data.addedQuota;
        const total = data.totalQuota;
        const final = DateToString.convertTimeToString(finalUsed - total);
        return final + " supplémentaires vous seront facturées à la fin du mois";
      }
      return '-';
    },
  },
  mutations: {
    updateQuotaLineMutation(state, response: QuotaLineAPIInterface) {
      let weekString = response.weekNumber.toString() + '-' + response.year.toString();
      if(response.weekNumber < 10) weekString = '0' + weekString;
      if (!state.quotaData.hasOwnProperty(weekString)) {
        Vue.set(state.quotaData, weekString, {});
      }
      Vue.set(state.quotaData[weekString], 'totalQuota', response.totalQuota);
      Vue.set(state.quotaData[weekString], 'usedQuota', response.usedQuota);
    },
    updateAddedQuota(state, addedQuota: Record<string, number>) {
      if (typeof addedQuota === "undefined") return;
      const addedQuotaLeft = JSON.parse(JSON.stringify(addedQuota));

      // Ajouter les élements qui existent déjà dans le store
      for (let weekNumber in state.quotaData) {
        if (!state.quotaData.hasOwnProperty(weekNumber)) continue;
        weekNumber = weekNumber.toString();

        const newValue = addedQuota.hasOwnProperty(weekNumber) ? addedQuota[weekNumber] : 0;
        Vue.set(state.quotaData[weekNumber], 'addedQuota', newValue);
        delete addedQuotaLeft[weekNumber];
      }

      // Ajouter les élements qui n'existent pas encore dans le store
      for (let weekNumber in addedQuotaLeft) {
        if (!addedQuotaLeft.hasOwnProperty(weekNumber)) continue;
        weekNumber = weekNumber.toString();

        Vue.set(state.quotaData, weekNumber.toString(), {});
        Vue.set(state.quotaData[weekNumber], 'addedQuota', addedQuotaLeft[weekNumber]);
      }
    },
    updateInitialFormQuota(state, initialFormQuota: Record<string, number>) {
      if (typeof initialFormQuota === "undefined") return;

      for (const weekNumber in initialFormQuota) {
        if (!initialFormQuota.hasOwnProperty(weekNumber)) continue;

        if (!state.quotaData.hasOwnProperty(weekNumber)) {
          Vue.set(state.quotaData, weekNumber.toString(), {});
        }
        Vue.set(state.quotaData[weekNumber], 'initialFormQuota', initialFormQuota[weekNumber]);
      }
    },
    unsetQuotaInformations(state) {
      Vue.set(state, 'quotaData', {});
    }
  },
  actions: {
    updateQuotaLine({commit}, quotaLine: QuotaLineConfig) {
      if (typeof quotaLine === "undefined" || quotaLine.weekNumber === "" || quotaLine.year === "") return;

      api.authRequest.get('clients/quota/' + this.state.authModule.user.client.id + '/' + quotaLine.weekNumber + '-' + quotaLine.year)
        .then((response: AxiosResponse<QuotaLineAPIInterface>) => {
          commit('updateQuotaLineMutation', response);
        })
        .catch((error: any) => {
          ErrorService.dealWithTheError(error);
        });
    },
  },
};

export default quotaLine;
